import _ from 'lodash';
import { COOKIE_DEFAULT_EXPIRY_TIME } from '../../../constants/defaults';
import { cloneBasket } from '../Basket';
import bffcli from '../bffcli';

const errorHandler = err => {
  console.log(err);
};

const getContactTracking = () => {
  let isEs = window.location.href.includes('/es');
  return {
    locale: isEs ? 'es-US' : 'en-US',
    domainUrl: window.location.origin
  };
};

export const getPoints = async () => {
  try {
    // Exceptions to be handled on component level
    const getPointsResponse = await bffcli.get(
      // TODO
      // `/loyalty/v1beta1/members/${encodeURIComponent(mProspectId)}/0/credits`
      `/loyalty/get-points`,
      { withCredentials: true }
    );
    if (!_.isEmpty(getPointsResponse.data)) {
      return getPointsResponse.data;
    }
  } catch (err) {
    errorHandler(err);
    return { amount: 0.0, isFromApi: false };
  }
};

export const login = async loginData => {
  // Exceptions to be handled on component level
  const loginObj = {
    ...loginData,
    ...getContactTracking()
  };
  const loginResponse = await bffcli.post('/user/logIn', loginObj);

  if (loginResponse && !_.isEmpty(loginResponse.data)) {
    const {
      firstName,
      lastName,
      prospectId,
      lastLogin,
      email,
      birthDate,
      confirmationRequired,
      emailVerificationRequired
    } = loginResponse.data;
    // Valid for 30 minutes
    if (!confirmationRequired && !emailVerificationRequired) {
      if (!_.isEmpty(lastLogin) && lastLogin === '0001-01-01T00:00:00Z') {
        cloneBasket(prospectId);
      }
    }
    if (confirmationRequired) {
      const userData = {
        FName: firstName,
        LName: lastName,
        Email: email,
        DateOfBirth: birthDate,
        prospectId,
        emailVerificationRequired
      };
      localStorage.setItem('userData', JSON.stringify(userData));
    }
  }
  return loginResponse;
};

export const oauthLogin = async oauthObj => {
  try {
    const loginResponse = await bffcli.post('/account/login', oauthObj);

    if (
      loginResponse &&
      loginResponse.data &&
      !_.isEmpty(loginResponse.data.Result)
    ) {
      const { FirstName, LastName, UserId, ApiToken } =
        loginResponse.data.Result;

      // Valid for 30 minutes
      _.setCookie(
        'user-name',
        `${FirstName} ${LastName}`,
        COOKIE_DEFAULT_EXPIRY_TIME
      );
      _.setCookie(
        'usertoken',
        `${UserId}!${ApiToken}`,
        COOKIE_DEFAULT_EXPIRY_TIME
      );

      return loginResponse;
    }
  } catch (err) {
    errorHandler(err);
    return err;
  }
};

export const signUp = async signUpData => {
  let { src, med, cgn } = _.getUTMParams();
  const signUpObj = {
    ...signUpData,
    contactTracking: getContactTracking(),
    referrerCode: _.getCookie('refCode'),
    utmSource: src,
    utmMedium: med,
    utmCampaign: cgn
  };
  const signUpResponse = await bffcli.post('/user/signUp', signUpObj);
  return signUpResponse;
};

export const logoutUser = async () => {
  _.eraseCookie('user-name');
  _.eraseCookie('usertoken');
  // _.eraseCookie('mprospect-id');
  _.eraseCookie('fname');
  _.eraseCookie('lname');
  _.eraseCookie('email');
  _.eraseCookie('birthDate');
};

export const logOutUser2 = async () => {
  try {
    return await bffcli.post('/user/logOut');
  } catch (err) {
    console.error('logout call failed');
  }
};

export const forgotPassword = async emailAddress => {
  // Exceptions to be handled on component level
  const forgotPasswordResponse = await bffcli.post('/user/forgot-password', {
    ...emailAddress,
    contactTracking: getContactTracking()
  });
  return forgotPasswordResponse;
};

export const confirmForgotPassword = async confirmPasswordData => {
  // Exceptions to be handled on component level
  const confirmForgotPasswordObj = {
    ...confirmPasswordData,
    contactTracking: getContactTracking()
  };
  const confirmForgotPasswordResp = await bffcli.post(
    '/user/confirm-forgot-password',
    confirmForgotPasswordObj
  );
  return confirmForgotPasswordResp;
};

export const changePassword = async changePasswordData => {
  // Exceptions to be handled on component level
  const changePasswordObj = {
    ...changePasswordData,
    contactTracking: getContactTracking()
  };
  const changePasswordResponse = await bffcli.post(
    '/user/change-password',
    changePasswordObj
  );
  return changePasswordResponse;
};

export const resendConfirmation = async email => {
  // Exceptions to be handled on component level
  /*
  const changePasswordResponse = await goServer.post(
    "/member/v1/Auth/ResendConfirmationCode",
    { email }
  );
  */
  const emailAddress = {
    email: email,
    tenantId: 0
  };
  const changePasswordResponse = await forgotPassword(emailAddress);
  return changePasswordResponse;
};

export const resendTempPassword = async email => {
  // Exceptions to be handled on component level

  /*const resendTempPasswordResp = await goServer.post(
    "/member/v1/Auth/ResendTemporaryPassword",
    { email }
  );*/
  const emailAddress = {
    email: email,
    tenantId: 0
  };
  const resendTempPasswordResp = await forgotPassword(emailAddress);
  return resendTempPasswordResp;
};

export const validateMail = async (email = '') => {
  try {
    const res = await bffcli.post(
      '/validate/email',
      { email },
      { withCredentials: true }
    );
    if (res) {
      return res.data;
    }
  } catch (err) {
    errorHandler(err);
    return err;
  }
};

export const newsletterSubscribe = async subscribeData => {
  try {
    const subscribeResponse = await bffcli.post(
      `/service-contact/sendNewsletterContact`,
      subscribeData
    );
    if (subscribeResponse) {
      return subscribeResponse;
    }
  } catch (err) {
    errorHandler(err);
    throw new Error(err);
  }
};

export const validateGuid = async (guid, isChangePassword) => {
  const url = isChangePassword
    ? '/user/validate-change-password-guid'
    : '/user/validate-reset-guid';
  try {
    const requestObj = isChangePassword
      ? { changePasswordGuid: guid }
      : { resetGuid: guid };
    const validateGuidResponse = await bffcli.post(url, requestObj);
    if (validateGuidResponse && validateGuidResponse.data) {
      return validateGuidResponse.data;
    }
  } catch (err) {
    errorHandler(err);
    return false;
  }
};

// TODO unused - to remove
// export const verifyUserByGuid = async (guid, isChangePassword) => {
//   try {
//     let url = `/member/v1/Auth/${
//       isChangePassword
//         ? 'VerifyUserByChangePasswordGuid'
//         : 'VerifyUserByResetGuid'
//     }`;
//     let requestObj = isChangePassword
//       ? { changePasswordGuid: guid }
//       : { resetGuid: guid };
//     const verifyUserByGuidResponse = await goServer.post(url, requestObj);
//     if (verifyUserByGuidResponse) {
//       return verifyUserByGuidResponse;
//     }
//   } catch (err) {
//     errorHandler(err);
//     return err;
//   }
// };

export const updateUserProfile = async userData => {
  const userDataObj = {
    ...userData,
    contactTracking: getContactTracking()
  };
  const updateUserResponse = await bffcli.post(
    '/user/update-profile',
    userDataObj
  );
  return updateUserResponse;
};

export const getmemberHistory = async () => {
  try {
    const memberHistoryResponse = await bffcli.post(
      '/user/transactions',
      {
        ...getContactTracking()
      },
      { withCredentials: true }
    );
    if (memberHistoryResponse) {
      return memberHistoryResponse.data;
    }
  } catch (err) {
    errorHandler(err);
    return err;
  }
};

export const updateUserDetails = async userData => {
  try {
    const updateUserResponse = await bffcli.post(
      '/user/updateData',
      {
        userData
      },
      { withCredentials: true }
    );
    if (updateUserResponse) {
      return updateUserResponse.data;
    }
  } catch (err) {
    errorHandler(err);
    return err;
  }
};

export const checkUserAgentData = async token => {
  try {
    const checkUserAgentResponse = await bffcli.post('/user/validate', {
      token
    });
    if (checkUserAgentResponse) {
      return checkUserAgentResponse.data;
    }
  } catch (err) {
    errorHandler(err);
    return err;
  }
};

export const checkUserStatus = async email => {
  try {
    const checkUserResponse = await bffcli.post('/user/status', {
      email,
      ...getContactTracking()
    });
    if (checkUserResponse) {
      return checkUserResponse.data;
    }
  } catch (err) {
    errorHandler(err);
    return err;
  }
};

export const deleteAccount = async (email, password) => {
  const deleteResponse = await bffcli.post('/user/deleteAccount', {
    email: email,
    password: password
  });
  return deleteResponse;
};
